var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"title":("Wstępne dane za rok " + _vm.reportYear),"description":"Dane zbierane w celach staystycznych"}},[_c('PreliminaryReport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }